export default __webpack_public_path__ + "static/media/650.8f4076e3.gif";